import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function PrivacyPolicy() {
  return <div className="min-h-screen bg-[#f4f7f9] font-sans text-slate-800" data-id="element-653">
      {/* Header Section */}
      <header className="bg-[#0f2546] text-white pt-8 pb-8 px-6 md:px-12" data-id="element-654">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-655">
          <Link to="/" className="flex items-center space-x-2" data-id="element-656">
            <span className="text-2xl font-bold tracking-tight" data-id="element-657">
              Swedenmark <span className="text-blue-400" data-id="element-658">AI</span>
            </span>
          </Link>
          <Link to="/" className="text-slate-300 hover:text-white flex items-center gap-2 text-sm transition-colors font-medium" data-id="element-659">
            <ArrowLeftIcon size={16} data-id="element-660" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content Section */}
      <main className="max-w-4xl mx-auto px-6 md:px-12 py-12" data-id="element-661">
        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-200" data-id="element-662">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-663">
            Privacy Policy
          </h1>
          <p className="text-slate-500 mb-10 font-medium" data-id="element-664">
            Effective Date: March 18, 2026
          </p>

          <div className="space-y-8 text-slate-700 leading-relaxed" data-id="element-665">
            <section data-id="element-666">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-667">
                1. Introduction
              </h2>
              <p data-id="element-668">
                Welcome to Swedenmark AI ("we," "our," or "us"). We are
                committed to protecting your privacy and ensuring you have a
                positive experience on our website (swedenmark.ai) and in using
                our AI automation and growth consulting services. This Privacy
                Policy explains how we collect, use, disclose, and safeguard
                your information when you visit our website or interact with our
                services, including our Live Demo feature.
              </p>
            </section>

            <section data-id="element-669">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-670">
                2. Information We Collect
              </h2>
              <p className="mb-2" data-id="element-671">
                We may collect personal information that you voluntarily provide
                to us when you express an interest in obtaining information
                about us or our products and services. The personal information
                that we collect depends on the context of your interactions with
                us and may include:
              </p>
              <ul className="list-disc pl-5 space-y-1" data-id="element-672">
                <li data-id="element-673">Full Name</li>
                <li data-id="element-674">Email Address</li>
                <li data-id="element-675">Company Name</li>
                <li data-id="element-676">Phone Number (optional)</li>
                <li data-id="element-677">
                  Free-text information provided in the "Tell us about yourself"
                  field
                </li>
              </ul>
            </section>

            <section data-id="element-678">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-679">
                3. How We Use Your Information
              </h2>
              <p className="mb-2" data-id="element-680">
                We use personal information collected via our website for a
                variety of business purposes described below:
              </p>
              <ul className="list-disc pl-5 space-y-1" data-id="element-681">
                <li data-id="element-682">
                  To provide, operate, and maintain our website and services.
                </li>
                <li data-id="element-683">
                  To deliver the Live Demo experience, which includes sending
                  automated, personalized emails and/or SMS messages based on
                  the information you provide.
                </li>
                <li data-id="element-684">
                  To respond to your inquiries and offer support or consulting
                  services.
                </li>
                <li data-id="element-685">
                  To send administrative information, marketing communications,
                  and updates related to our services.
                </li>
              </ul>
            </section>

            <section data-id="element-686">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-687">
                4. SMS/Text Messaging
              </h2>
              <p className="mb-3" data-id="element-688">
                By providing your phone number and checking the consent box on
                our Live Demo form, you consent to receive automated text
                messages from Swedenmark AI. These messages are used to
                demonstrate our AI automation capabilities and follow up on your
                inquiry.
              </p>
              <p className="font-semibold text-gray-900 mb-2" data-id="element-689">
                Twilio Compliance & Data Sharing:
              </p>
              <p data-id="element-690">
                We respect your privacy regarding mobile information. Mobile
                information will not be shared with third parties or affiliates
                for marketing or promotional purposes. All the above categories
                exclude text messaging originator opt-in data and consent; this
                information will not be shared with any third parties. You can
                opt out of receiving SMS messages at any time by replying "STOP"
                to any message you receive from us.
              </p>
            </section>

            <section data-id="element-691">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-692">
                5. Email Communications
              </h2>
              <p data-id="element-693">
                If you provide your email address, we may send you personalized
                emails as part of our Live Demo, as well as follow-up
                communications regarding our consulting services. You may opt
                out of our email marketing list at any time by clicking the
                "unsubscribe" link in the emails that we send.
              </p>
            </section>

            <section data-id="element-694">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-695">
                6. Data Sharing & Third Parties
              </h2>
              <p data-id="element-696">
                We do not sell, rent, or trade your personal information to
                third parties. We may share your data with trusted third-party
                service providers who perform services for us or on our behalf
                and require access to such information to do that work. This
                includes our automation platform (n8n), our SMS gateway
                (Twilio), and our email service providers. These third parties
                are bound by strict confidentiality agreements and are permitted
                to use your data only to provide services to Swedenmark AI.
              </p>
            </section>

            <section data-id="element-697">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-698">
                7. Data Security
              </h2>
              <p data-id="element-699">
                We have implemented appropriate technical and organizational
                security measures designed to protect the security of any
                personal information we process. However, despite our safeguards
                and efforts to secure your information, no electronic
                transmission over the Internet or information storage technology
                can be guaranteed to be 100% secure.
              </p>
            </section>

            <section data-id="element-700">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-701">
                8. Data Retention
              </h2>
              <p data-id="element-702">
                We will only keep your personal information for as long as it is
                necessary for the purposes set out in this Privacy Policy,
                unless a longer retention period is required or permitted by law
                (such as tax, accounting, or other legal requirements).
              </p>
            </section>

            <section data-id="element-703">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-704">
                9. Your Rights
              </h2>
              <p data-id="element-705">
                Depending on your location, you may have certain rights
                regarding your personal information, such as the right to
                request access to, correct, amend, delete, or limit the use of
                your personal data. To exercise these rights, please contact us
                using the information provided below.
              </p>
            </section>

            <section data-id="element-706">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-707">
                10. Children's Privacy
              </h2>
              <p data-id="element-708">
                Our services are intended for business professionals and are not
                directed to children under the age of 18. We do not knowingly
                collect personal information from children under 18.
              </p>
            </section>

            <section data-id="element-709">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-710">
                11. Changes to This Policy
              </h2>
              <p data-id="element-711">
                We may update this Privacy Policy from time to time. The updated
                version will be indicated by an updated "Effective Date" and the
                updated version will be effective as soon as it is accessible.
                We encourage you to review this Privacy Policy frequently to be
                informed of how we are protecting your information.
              </p>
            </section>

            <section data-id="element-712">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-713">
                12. Contact Us
              </h2>
              <p data-id="element-714">
                If you have questions or comments about this policy, you may
                email us at{' '}
                <a href="mailto:hello@swedenmark.ai" className="text-blue-600 hover:underline" data-id="element-715">
                  hello@swedenmark.ai
                </a>{' '}
                or contact us by mail at:
              </p>
              <address className="mt-2 not-italic text-slate-600" data-id="element-716">
                Swedenmark AI
                <br data-id="element-717" />
                Pompano Beach, FL
                <br data-id="element-718" />
                United States
              </address>
            </section>
          </div>
        </div>
      </main>
    </div>;
}